import { default as AsyncPickerDeprecated } from './AsyncPicker';
import { warnDeprecated } from '../../internal/utilities/warnDeprecated';
import { pickerDeprecationMessage } from '../Picker';

export const AsyncPicker = warnDeprecated(AsyncPickerDeprecated, pickerDeprecationMessage);
export * from './AsyncPicker.types';
